export default __webpack_public_path__ + "static/media/C-chop It Off.b15be3ff.png";